export default "__VITE_ASSET__HMGtqw$J__"